exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#GradeDescription {\n  padding: 0.16rem;\n  font-size: 0.15rem;\n  color: #1E283C;\n}\n#GradeDescription h2 {\n  font-size: 0.18rem;\n}\n#GradeDescription h3 {\n  margin: 0.05rem 0;\n  font-size: 0.15rem;\n}\n#GradeDescription section {\n  margin: 0.12rem 0;\n}\n#GradeDescription .table1 {\n  border-style: solid;\n  border-width: 1px;\n  border-color: #000;\n}\n#GradeDescription .table-view {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n#GradeDescription .table-clumn {\n  -ms-flex: 1 1;\n      flex: 1 1;\n  border-style: solid;\n  border-width: 1px;\n  border-color: #000;\n  word-wrap: break-word;\n  overflow: hidden;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"modifyVars":{"@brand-primary":"#1DA57A","@primary-button-fill":"#1DA295"}}!./src/staticPage/gradeDescription/index.less
// module id = 350
// module chunks = 0